import { coreAxios } from '@/declare/api/axios'
import { MaterialMark } from '@/declare/interface/project/material'
import { Axios, AxiosResponse } from "axios"



/**
 * 获取项目材料关联
 *
 * @param projectUuid
 * @param materialType
 * @return
 */
export function findProjectMaterials(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/project-materials`, {
        params: {
            ...params,
        }
    })

}

/**
 * 创建并关联新的系统材料
 *
 * @param projectUuid
 * @param material
 * @return
 */

export function createMaterial(projectUuid: string, material: MaterialMark, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/project-materials/materials`, material, {
        params: {
            ...params,
        }
    })

}


/**
 * 创建项目材料关联
 *
 * @param projectUuid
 * @param materialUuids
 * @return
 */
export function createProjectMaterial(projectUuid: string, materialUuids: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/project-materials`, materialUuids, {
        params: {
            ...params,
        }
    })

}

/**
 * 删除项目材料库的引用关系
 *
 * @param projectMaterialId
 * @return
 */
export function deleteProjectMaterial(projectMaterialId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/project-materials/${projectMaterialId}`, {
        params: {
            ...params,
        }
    })

}

/**
 * 批量删除项目材料库的引用关系
 *
 * @param projectUuid
 * @param materialUuids
 * @return
 */
export function deleteProjectMaterialMulti(projectUuid: string, materialUuids: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/project-materials/multi-delete`, materialUuids, {
        params: {
            ...params,
        }
    })

}